/* global axios */
import ApiClient from './ApiClient';

class DigitalHumansAPI extends ApiClient {
  constructor() {
    super('digital_humans', { accountScoped: true });
  }

  updateWithInboxes(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  createWithInboxes(data) {
    return axios.post(this.url, data);
  }

  testIntegration(id, { api_key, base_url }) {
    return axios.post(`${this.url}/${id}/test_integration`, {
      api_key,
      base_url,
    });
  }

  // Histórico de versões do prompt + sincronização com o Supabase (experimental)
  getPromptVersions(id) {
    return axios.get(`${this.url}/${id}/prompt_versions`);
  }

  getPromptVersion(id, versionId) {
    return axios.get(`${this.url}/${id}/prompt_versions/${versionId}`);
  }

  restorePromptVersion(id, versionId, expectedCurrentDigest) {
    return axios.post(
      `${this.url}/${id}/prompt_versions/${versionId}/restore`,
      {
        expected_current_digest: expectedCurrentDigest,
      }
    );
  }

  previewPromptSync(id) {
    return axios.get(`${this.url}/${id}/prompt_versions/sync_preview`);
  }

  applyPromptSync(id, { currentDigest, incomingDigest }) {
    return axios.post(`${this.url}/${id}/prompt_versions/sync`, {
      expected_current_digest: currentDigest,
      expected_incoming_digest: incomingDigest,
    });
  }
}

export default new DigitalHumansAPI();
